import { useEffect, useState } from 'react';
import { Col, Form, Modal, Row, Switch } from 'antd';
import { TextService } from '../../Services/TextService';
import { BookyButton } from '../Buttons/BookyButton';
import { CookieConcentInformation } from '../../Types/CookieConcentInformation';

export const CookieSettingsModal = (props: any) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const GetText = TextService.GetText;
    const [functionalCookieSelection, setFunctionalCookieSelection] = useState(true);
    const [marketingCookieSelection, setMarketingCookieSelection] = useState(true);

    const onCancel = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (props.cookieConcent) {
            setFunctionalCookieSelection(props.cookieConcent.functional);
            setMarketingCookieSelection(props.cookieConcent.analytics);
        }
    }, [props]);

    const onCreate = async () => {
        const savedConcent: CookieConcentInformation = {
            timeStamp: new Date(),
            functional: functionalCookieSelection,
            analytics: marketingCookieSelection
        }

        props.onCookieSave(savedConcent);
        setOpen(false);
    }
    return (
        <>
            <Modal
                open={open}
                title={GetText("CookieSettingsModal_ModalTitle")}
                width={700}
                okText={GetText("EditMember_ModalClose")}
                onOk={onCancel}
                okButtonProps={{ type: "default" }}
                onCancel={onCancel}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <Form form={form} labelAlign={"left"} labelCol={{ span: 8, offset: 0 }}>
                    <Col span={22}>

                        <Row>
                            <Col span={15}>
                                <div className="cookieCategoryContainer">
                                    <b>{GetText("CookieSettingsModal_EssenialCookie")}</b>
                                    <p>{GetText("CookieSettingsModal_EssenialCookieText")}</p>
                                </div>
                            </Col>
                            <Col style={{ textAlign: "right" }} span={6}>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={15}>
                                <div className="cookieCategoryContainer">
                                    <b>{GetText("CookieSettingsModal_FunctionalCookie")}</b>
                                    <p>{GetText("CookieSettingsModal_FunctionalCookieText")}</p>
                                </div>
                            </Col>
                            <Col style={{ textAlign: "right" }} span={6}>
                                <Switch checked={functionalCookieSelection} onChange={(e) => { setFunctionalCookieSelection(!functionalCookieSelection) }} defaultChecked />
                            </Col>
                        </Row>

                        <Row>
                            <Col span={15}>
                                <div className="cookieCategoryContainer">
                                    <b>{GetText("CookieSettingsModal_MarketingCookie")}</b>
                                    <p>{GetText("CookieSettingsModal_MarketingCookieText")}</p>
                                </div>
                            </Col>
                            <Col style={{ textAlign: "right" }} span={6}>
                                <Switch checked={marketingCookieSelection} onChange={(e) => { setMarketingCookieSelection(!marketingCookieSelection) }} defaultChecked />
                            </Col>
                        </Row>

                        <BookyButton

                            fullWidth={false}
                            text={GetText("Common_Save")}
                            onClick={onCreate}
                        >
                        </BookyButton>
                    </Col>
                </Form>
            </Modal>

            <BookyButton type={props.type} onClick={() => {
                setOpen(true);
            }} fullWidth={props.fullWidth} text={props.text} />
        </>
    );
};